module.exports = __webpack_public_path__ + "img/1065.37ff95d4.gif";